import instance from "@/api/instance";

export const timestamp = Date.now();

// 图片上传接口
export const uploadFile = (data) =>
  instance({
    url: "/common/uploadFile",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getHomeList = (data) =>
  instance({
    url: "/frontend/home/index",
    method: "post",
    data: data,
  });

// 获取通知公告详情
export const getNoticeDetail = (id) => instance.get("/frontend/home/newsDetail?id=" + id);


export const getBaseUrl = (data) =>
  instance({
    url: window.location.hostname + '/get-domain',
    method: "get",
  });
export const getNewsList = (data) =>
  instance({
    url: "/frontend/home/newsList",
    method: "get",
    params: data,
  });
export const getRecommendList = (data) =>
  instance({
    url: "/frontend/home/recommendList",
    method: "get",
    params: data,
  });


export const getExpertList = (data) =>
  instance({
    url: "/frontend/home/expertList",
    method: "get",
    params: data,
  });
export const getSummary = (data) =>
  instance({
    url: "/frontend/home/summary",
    method: "get",
    params: data,
  });
export const getChartList = (data) =>
  instance({
    url: "/frontend/home/chartList",
    method: "get",
    params: data,
  });

export const getLoginRecommendList = (data) =>
  instance({
    url: "/frontend/login/recommendList",
    method: "get",
    params: data,
  });
export const getDict = (data) =>
  instance({
    url: "/frontend/home/dict",
    method: "get",
    params: data,
  });

export const goRegister = (data) =>
  instance({
    url: "/frontend/login/register",
    method: "post",
    data: data,
  });

/* ********* 登录 ********* */
//手机登录
export const loginCellphone = (data) => {
  return instance({
    url: "/frontend/login",
    method: "post",
    data: data,
  });
};

export const saveProjectContacts = (data) => {
  return instance({
    url: "/frontend/home/save_project_contacts",
    method: "post",
    data: data,
  });
};

export const getProvinceList = (data) =>
  instance({
    url: "/common/getCityList",
    method: "get",
    params: data,
  });
export const getSelectList = (data) =>
  instance({
    url: "/frontend/project/getSelect",
    method: "get",
    params: data,
  });
export const getAchievementList = (data) =>
  instance({
    url: "/frontend/project/index",
    method: "get",
    params: data,
  });
export const getAchievementDetail = (data) =>
  instance({
    url: "/frontend/project/detail",
    method: "get",
    params: data,
  });
export const deleteAchievement = (data) =>
  instance({
    url: "/frontend/project/del",
    method: "get",
    params: data,
  });
export const getRecommendationDetail = (data) =>
  instance({
    url: "/frontend/opinion/detail",
    method: "get",
    params: data,
  });
export const refuseStatus = (data) =>
  instance({
    url: "/frontend/project/refuse",
    method: "get",
    params: data,
  });
export const getMemberList = (data) =>
  instance({
    url: "/frontend/member",
    method: "get",
    params: data,
  });
export const getHomeProject = (data) =>
  instance({
    url: "/frontend/home/projectList",
    method: "get",
    params: data,
  });

export const addAchievement = (data) => {
  return instance({
    url: "/frontend/project/save",
    method: "post",
    data: data,
  });
};
export const addOpinion = (data) => {
  return instance({
    url: "/frontend/opinion/save",
    method: "post",
    data: data,
  });
};
export const getProjectContacts = (data) =>
  instance({
    url: "/frontend/project_contacts",
    method: "get",
    params: data,
  });
export const getCopDetail = (data) =>
  instance({
    url: "/frontend/project_contacts/detail",
    method: "get",
    params: data,
  });

export const getSendSms = (data) =>
  instance({
    url: "/frontend/login/sendSms",
    method: "get",
    params: data,
  });

export const getGame = (data) =>
  instance({
    url: "/frontend/home/gameSelect",
    method: "get",
    params: data,
  });
export const getCurrGames = (data) =>
  instance({
    url: "/frontend/home/gamesInfo",
    method: "get",
    params: data,
  });
export const goForget = (data) => {
  return instance({
    url: "/frontend/login/forget",
    method: "post",
    data: data,
  });
};
export const goPerfectInfo = (data) => {
  return instance({
    url: "/frontend/member/save",
    method: "post",
    data: data,
  });
};

export const saveSignature = (data) => {
  return instance({
    url: "/frontend/judge/signature",
    method: "post",
    data: data,
  });
};
export const saveScore = (data) => {
  return instance({
    url: "/frontend/judge/saveScore",
    method: "post",
    data: data,
  });
};
export const getJudge = (data) =>
  instance({
    url: "/frontend/judge",
    method: "get",
    params: data,
  });
export const getExpertScore = (data) =>
  instance({
    url: "/frontend/judge/expertScore",
    method: "get",
    params: data,
  });
export const getScoreList = (data) =>
  instance({
    url: "/frontend/judge/formPaper",
    method: "get",
    params: data,
  });
export const getScoreDetail = (data) =>
  instance({
    url: "/frontend/judge/scoreDetail",
    method: "get",
    params: data,
  });
export const getReview = (data) =>
  instance({
    url: "/frontend/judge/review",
    method: "get",
    params: data,
  });

  export const getExpertReviewDetail = (data) =>
    instance({
      url: "/frontend/judge/review",
      method: "get",
      params: data,
    });
    export const getJudgeProject = (data) =>
      instance({
        url: "/frontend/judge/judgeProject",
        method: "get",
        params: data,
      });
      export const cerQuery = (data) =>
        instance({
          url: "/frontend/cer/cerQuery",
          method: "get",
          params: data,
        });

// 获取用户详细
export const userDetail = () => instance.get("/frontend/about/memberInfo");
// 登录状态
export const loginStatus = () => instance.get("/login/status");
// 退出登录
export const logout = () => instance.get("/logout");

export default {
  cerQuery,
  getJudgeProject,
  getExpertReviewDetail,
  getReview,
  getScoreDetail,
  saveScore,
  getScoreList,
  getExpertScore,
  saveSignature,
  getJudge,
  getBaseUrl,
  getCurrGames,
  getGame,
  userDetail,
  goPerfectInfo,
  goForget,
  getSendSms,
  saveProjectContacts,
  getHomeProject,
  getCopDetail,
  getProjectContacts,
  getMemberList,
  refuseStatus,
  addOpinion,
  getRecommendationDetail,
  deleteAchievement,
  getAchievementDetail,
  getAchievementList,
  addAchievement,
  getDict,
  getSelectList,
  getProvinceList,
  uploadFile,
  getLoginRecommendList,
  goRegister,
  getChartList,
  getSummary,
  getExpertList,
  getRecommendList,
  getNewsList,
  getNoticeDetail,
  getHomeList,
  loginCellphone,
  logout,
};
